import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WebsiteServiceService } from 'src/app/listing/shared/website-service.service';
import { ProfileSearchService } from 'src/app/profiles/search';
import { ProfileSearchComponentModel } from 'src/app/profiles/search/profile-search-component.model';
import { BulkReferralDto } from 'src/app/profiles/shared/dto/bulk-referral-add.dto';
import { ReferralSummaryDto } from 'src/app/profiles/shared/dto/referral-summary.dto';
import { ReferralType } from 'src/app/profiles/shared/dto/referral-type.dto';
import { ProfileReferralService } from 'src/app/profiles/shared/profile-referral.service';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-add-referral-dialog',
  templateUrl: './add-referral-dialog.component.html',
  styleUrls: ['./add-referral-dialog.component.less'],
    standalone: false
})
export class AddReferralDialogComponent {
  @Input() profileId;
  profileSearchComponentModel: ProfileSearchComponentModel;
  @Output() referralAdded = new EventEmitter<boolean>();

  show: boolean = false;
  isBulkReferralAdd: boolean = false;
  referralSummary = { ReferralDate: new Date() } as ReferralSummaryDto;
  referralTypes = Array<ReferralType>();
  public constructor(
    private _profileReferralService: ProfileReferralService,
    private _websiteService: WebsiteServiceService,
    private _notificationService: NotificationService,
    private _profileSearchService: ProfileSearchService
  ) {}

  public open(isBulkReferralAdd = false, profileSearchComponentModel = {} as ProfileSearchComponentModel) {
    this.isBulkReferralAdd = isBulkReferralAdd;
    this.profileSearchComponentModel = profileSearchComponentModel;
    this._profileReferralService.getReferralTypes().then((data) => {
      this.referralTypes = data;
    });
    this.show = true;
  }

  public close() {
    this.show = false;
  }

  public addReferral() {
    this.referralSummary.FirstReferralDateTime = this.referralSummary.ReferralDate;
    this.referralSummary.LastReferralDateTime = this.referralSummary.ReferralDate;

    if (this.isBulkReferralAdd) {
      let bulkReferral = {
        Referral: this.referralSummary,
      } as BulkReferralDto;

      if (this.profileSearchComponentModel.selectAllProfiles) {
        this.profileSearchComponentModel.searchParams.PageSize = 0;
        this.profileSearchComponentModel.searchParams.IgnoreProfiles.push(...this.profileSearchComponentModel.selectedProfiles);
        this._profileSearchService.advancedSearch(this.profileSearchComponentModel.searchParams).then((result) => {
          bulkReferral.ProfileIds = result.Result.map((profile) => profile.ProfileId);
          this.addBulkReferral(bulkReferral);
        });
      } else {
        bulkReferral.ProfileIds = this.profileSearchComponentModel.selectedProfiles;
        this.addBulkReferral(bulkReferral);
      }
    } else {
      this.referralSummary.ProfileID = this.profileId;
      this._profileReferralService
        .addReferral(this.referralSummary)
        .then(() => {
          this.referralAdded.emit();
          this.referralSummary = {} as ReferralSummaryDto;
          this.close();
        })
        .catch((error) => {
          this._notificationService.httpError(error);
        });
    }
  }

  private addBulkReferral(bulkReferral: BulkReferralDto) {
    this._websiteService
      .bulkLogReferrals(bulkReferral)
      .then(() => {
        this.referralSummary = {} as ReferralSummaryDto;
        this.close();
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      });
  }
}
